import { render, staticRenderFns } from "./WaitingListEdit.vue?vue&type=template&id=1144f6b8&scoped=true"
import script from "./WaitingListEdit.vue?vue&type=script&lang=js"
export * from "./WaitingListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1144f6b8",
  null
  
)

export default component.exports